function cov_1jx6gttwp() {
  var path = "/app/src/components/default-promo-widget/components/ltf-snippet/components/subvention-offer/subvention-offer.tsx";
  var hash = "baeb3e2781e48a2b226b778cec9d76ea22cdbf0b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/ltf-snippet/components/subvention-offer/subvention-offer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 31
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 14,
          column: 23
        }
      },
      "2": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 34,
          column: 4
        }
      },
      "3": {
        start: {
          line: 26,
          column: 29
        },
        end: {
          line: 26,
          column: 54
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 31
          },
          end: {
            line: 13,
            column: 32
          }
        },
        loc: {
          start: {
            line: 13,
            column: 53
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 17
          },
          end: {
            line: 26,
            column: 18
          }
        },
        loc: {
          start: {
            line: 26,
            column: 29
          },
          end: {
            line: 26,
            column: 54
          }
        },
        line: 26
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "baeb3e2781e48a2b226b778cec9d76ea22cdbf0b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jx6gttwp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jx6gttwp();
import React from 'react';
import { useLocale } from 'src/hooks/use-locale';
import { Icon } from '../../../../../icon';
import { Typography } from '../../../../../v2/typography';
import styles from './styles.css';
cov_1jx6gttwp().s[0]++;
export var SubventionOffer = function SubventionOffer(_ref) {
  var offer = _ref.offer;
  cov_1jx6gttwp().f[0]++;
  var t = (cov_1jx6gttwp().s[1]++, useLocale());
  cov_1jx6gttwp().s[2]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.dealIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "deal"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1"
  }, t('pay_in_x_interest_free_payments_on_eligible_items', {
    paymentsCount: offer.paymentsCount
  }, {
    b: function b(string) {
      cov_1jx6gttwp().f[1]++;
      cov_1jx6gttwp().s[3]++;
      return /*#__PURE__*/React.createElement("strong", null, string);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.arrowIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow"
  })));
};